import React from 'react';
import styled from 'styled-components';

import { Cell, Container, Grid } from '@zeiss/ods-components-react';

import { Text } from '../../../../components';
import {
  StyledContainer,
  StyledHeadline,
  StyledMainDescription,
} from '../../styled';
import { useSlider } from '../../../../hooks';

export const StyledBackground = styled.span`
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  width: 100%;
  height: var(--main-height);
  background-image: url('./images/info-pages/info-project-bgimage.jpg');
  background-size: cover;
  background-repeat: no-repeat;
  z-index: -1;
`;

const Project = ({
  title,
  description,
  index,
}: {
  description: string;
  index: number;
  title: string;
}) => {
  const ref = React.createRef<HTMLVideoElement>();

  const { activeSlide } = useSlider();
  React.useEffect(() => {
    if (ref.current && index !== activeSlide) {
      ref.current.pause();
      ref.current.currentTime = 0;
    }
  }, [activeSlide, ref]);

  return (
    <>
      <StyledBackground />
      <StyledContainer>
        <Grid>
          <Container.FullBleed>
            <Cell.Basic colStarts={2} colSpan={4}>
              <Grid>
                <Container.FullBleed>
                  <Cell.Basic colSpan={12}>
                    <StyledHeadline headline={title} />
                  </Cell.Basic>
                  <Cell.Basic colSpan={12}>
                    <StyledMainDescription size="l">
                      {description}
                    </StyledMainDescription>
                  </Cell.Basic>
                  <Cell.Basic colSpan={6}>
                    <Text size="m">
                      In his creative residency at the ZEISS Innovation Hub @
                      KIT in the fall of 2021, the musician and artist Emmanuel
                      Witzthum engaged with precisely these questions. He
                      accompanied ZEISS employees during the brainstorming,
                      implementation, and presentation of innovation projects,
                      observed the Hub team in their everyday work, and actively
                      introduced artistic approaches and ways of thinking into
                      scientific practice.
                    </Text>
                  </Cell.Basic>
                  <Cell.Basic colSpan={6}>
                    <Text size="m">
                      Witzthum brought these experiences to bear on his new work
                      The Contour of Stars. The heart of the composition is a
                      graphic score that visualizes the processes of thought,
                      discussion, and negotiation that characterized the
                      collaboration. To complement Witzthum’s piece, Ensemble
                      Modern will perform other works based on graphic notation.
                    </Text>
                  </Cell.Basic>
                </Container.FullBleed>
              </Grid>
            </Cell.Basic>
            <Cell.Basic colSpan={6}>
              {/* eslint-disable-next-line jsx-a11y/media-has-caption */}
              <video ref={ref} src="./videos/Project-Video.mp4" controls>
                <source src="./videos/Project-Video.mp4" type="video/mp4" />
              </video>
            </Cell.Basic>
          </Container.FullBleed>
        </Grid>
      </StyledContainer>
    </>
  );
};

export default Project;
